function iframeResize(source) {
  const canvas = document.getElementsByClassName('dialog-off-canvas-main-canvas')[0];

  if (
    !canvas
    || !window.drupalSettings
    || window.drupalSettings?.featureFlags?.full_page
  ) {
    return;
  }

  window.parent.postMessage({
    type: 'resizeFrame',
    source,
    height: canvas.scrollHeight,
  }, '*');
}

export {
  iframeResize,
};
